<button (click)="copyToClipboard(field().variable)" [attr.isInteractive]="isInteractive()">
  @if (fieldIcons[field().type]) {
    <div [attr.custom]="field().custom">
      <sb-icon [name]="fieldIcons[field().type]" [size]="'sm'" />
    </div>
  }
  <span>{{ field().label }}</span>
  <sb-icon name="copy-2-regular" [size]="'sm'" />
</button>
